import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <header style={{
        backgroundColor: '#1976d2',
        color: 'white',
        padding: '10px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <h1 style={{ margin: 0, fontSize: '24px' }}>{t('auth.title')}</h1>
        <nav style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          {user?.isAdmin ? (
            /* Admin navigation - admin panel and monitoring */
            <>
              <Link to="/admin" style={{ color: 'white', textDecoration: 'none' }}>
                Пользователи
              </Link>
              <Link to="/admin/monitoring" style={{ color: 'white', textDecoration: 'none' }}>
                Мониторинг
              </Link>
            </>
          ) : (
            /* Regular user navigation */
            <>
              <Link to="/create-job" style={{ color: 'white', textDecoration: 'none' }}>
                {t('navigation.createJob')}
              </Link>
              <Link to="/jobs" style={{ color: 'white', textDecoration: 'none' }}>
                {t('navigation.jobs')}
              </Link>
              <Link to="/settings" style={{ color: 'white', textDecoration: 'none' }}>
                {t('navigation.settings')}
              </Link>
            </>
          )}
          <span style={{ color: 'rgba(255,255,255,0.8)' }}>{user?.username}</span>
          <button
            onClick={logout}
            style={{
              backgroundColor: 'rgba(255,255,255,0.2)',
              border: 'none',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            {t('auth.logout')}
          </button>
        </nav>
      </header>
      <main style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
        {children}
      </main>
    </div>
  );
};

export default Layout;
